require("../../scss/web/_variables.scss")
require("../../scss/custom/dog_age_calculator.sass")

document.addEventListener("turbolinks:load", () => {
  $('input.dog_age_size').on('change', event => {
    $('input.dog_age_size + .size-button').removeClass('selected');
    $(event.target).siblings('.size-button').addClass('selected');
  });

  if ($('#dog_age_params').length !== 0) {
    const dogAge = Number($('#dog_age_year').val()) * 12 + Number($('#dog_age_month').val());
    const ageData = {
      1: [1.25, 1.25, 1.25],
      2: [2.5, 2.5, 2.5],
      3: [3.75, 3.75, 3.75],
      4: [5, 5, 5],
      5: [6.25, 6.25, 6.25],
      6: [7.5, 7.5, 7.5],
      7: [8.75, 8.75, 8.75],
      8: [10, 10, 10],
      9: [11.25, 11.25, 11.25],
      10: [12.5, 12.5, 12.5],
      11: [13.75, 13.75, 13.75],
      12: [15, 15, 15],
      13: [15.75, 15.75, 15.75],
      14: [16.5, 16.5, 16.5],
      15: [17.25, 17.25, 17.25],
      16: [18, 18, 18],
      17: [18.75, 18.75, 18.75],
      18: [19.5, 19.5, 19.5],
      19: [20.25, 20.25, 20.25],
      20: [21, 21, 21],
      21: [21.75, 21.75, 21.75],
      22: [22.5, 22.5, 22.5],
      23: [23.25, 23.25, 23.25],
      24: [24, 24, 24],
      25: [24.3333333333333, 24.3333333333333, 24.3333333333333],
      26: [24.6666666666667, 24.6666666666667, 24.6666666666667],
      27: [25, 25, 25],
      28: [25.3333333333333, 25.3333333333333, 25.3333333333333],
      29: [25.6666666666667, 25.6666666666667, 25.6666666666667],
      30: [26, 26, 26],
      31: [26.3333333333333, 26.3333333333333, 26.3333333333333],
      32: [26.6666666666667, 26.6666666666667, 26.6666666666667],
      33: [27, 27, 27],
      34: [27.3333333333333, 27.3333333333333, 27.3333333333333],
      35: [27.6666666666667, 27.6666666666667, 27.6666666666667],
      36: [28, 28, 28],
      37: [28.3333333333333, 28.3333333333333, 28.3333333333333],
      38: [28.6666666666667, 28.6666666666667, 28.6666666666667],
      39: [29, 29, 29],
      40: [29.3333333333333, 29.3333333333333, 29.3333333333333],
      41: [29.6666666666666, 29.6666666666666, 29.6666666666666],
      42: [30, 30, 30],
      43: [30.3333333333333, 30.3333333333333, 30.3333333333333],
      44: [30.6666666666666, 30.6666666666666, 30.6666666666666],
      45: [31, 31, 31],
      46: [31.3333333333333, 31.3333333333333, 31.3333333333333],
      47: [31.6666666666666, 31.6666666666666, 31.6666666666666],
      48: [32, 32, 32],
      49: [32.3333333333333, 32.3333333333333, 32.3333333333333],
      50: [32.6666666666666, 32.6666666666666, 32.6666666666666],
      51: [33, 33, 33],
      52: [33.3333333333333, 33.3333333333333, 33.3333333333333],
      53: [33.6666666666667, 33.6666666666667, 33.6666666666667],
      54: [34, 34, 34],
      55: [34.3333333333333, 34.3333333333333, 34.3333333333333],
      56: [34.6666666666667, 34.6666666666667, 34.6666666666667],
      57: [35, 35, 35],
      58: [35.3333333333333, 35.3333333333333, 35.3333333333333],
      59: [35.6666666666667, 35.6666666666667, 35.6666666666667],
      60: [36, 36, 36],
      61: [36.3333333333333, 36.5, 36.75],
      62: [36.6666666666667, 37, 37.5],
      63: [37, 37.5, 38.25],
      64: [37.3333333333333, 38, 39],
      65: [37.6666666666667, 38.5, 39.75],
      66: [38, 39, 40.5],
      67: [38.3333333333333, 39.5, 41.25],
      68: [38.6666666666667, 40, 42],
      69: [39, 40.5, 42.75],
      70: [39.3333333333334, 41, 43.5],
      71: [39.6666666666667, 41.5, 44.25],
      72: [40, 42, 45],
      73: [40.3333333333334, 42.4166666666667, 45.4166666666667],
      74: [40.6666666666667, 42.8333333333333, 45.8333333333333],
      75: [41, 43.25, 46.25],
      76: [41.3333333333334, 43.6666666666667, 46.6666666666667],
      77: [41.6666666666667, 44.0833333333333, 47.0833333333333],
      78: [42, 44.5, 47.5],
      79: [42.3333333333334, 44.9166666666667, 47.9166666666667],
      80: [42.6666666666667, 45.3333333333333, 48.3333333333333],
      81: [43, 45.75, 48.75],
      82: [43.3333333333334, 46.1666666666666, 49.1666666666666],
      83: [43.6666666666667, 46.5833333333333, 49.5833333333333],
      84: [44.0000000000001, 47, 50],
      85: [44.3333333333334, 47.3333333333333, 50.4166666666666],
      86: [44.6666666666667, 47.6666666666666, 50.8333333333333],
      87: [45.0000000000001, 48, 51.25],
      88: [45.3333333333334, 48.3333333333333, 51.6666666666666],
      89: [45.6666666666667, 48.6666666666667, 52.0833333333333],
      90: [46.0000000000001, 49, 52.5],
      91: [46.3333333333334, 49.3333333333333, 52.9166666666666],
      92: [46.6666666666667, 49.6666666666667, 53.3333333333333],
      93: [47.0000000000001, 50, 53.75],
      94: [47.3333333333334, 50.3333333333333, 54.1666666666666],
      95: [47.6666666666667, 50.6666666666667, 54.5833333333333],
      96: [48.0000000000001, 51, 54.9999999999999],
      97: [48.3333333333334, 51.4166666666667, 55.4999999999999],
      98: [48.6666666666668, 51.8333333333333, 55.9999999999999],
      99: [49.0000000000001, 52.25, 56.4999999999999],
      100: [49.3333333333334, 52.6666666666667, 56.9999999999999],
      101: [49.6666666666668, 53.0833333333333, 57.4999999999999],
      102: [50.0000000000001, 53.5, 57.9999999999999],
      103: [50.3333333333334, 53.9166666666667, 58.4999999999999],
      104: [50.6666666666668, 54.3333333333333, 58.9999999999999],
      105: [51.0000000000001, 54.75, 59.4999999999999],
      106: [51.3333333333334, 55.1666666666666, 59.9999999999999],
      107: [51.6666666666668, 55.5833333333333, 60.4999999999999],
      108: [52.0000000000001, 56, 60.9999999999999],
      109: [52.3333333333334, 56.3333333333333, 61.4166666666666],
      110: [52.6666666666668, 56.6666666666666, 61.8333333333333],
      111: [53.0000000000001, 57, 62.2499999999999],
      112: [53.3333333333335, 57.3333333333333, 62.6666666666666],
      113: [53.6666666666668, 57.6666666666667, 63.0833333333333],
      114: [54.0000000000001, 58, 63.4999999999999],
      115: [54.3333333333335, 58.3333333333333, 63.9166666666666],
      116: [54.6666666666668, 58.6666666666667, 64.3333333333333],
      117: [55.0000000000001, 59, 64.7499999999999],
      118: [55.3333333333335, 59.3333333333333, 65.1666666666666],
      119: [55.6666666666668, 59.6666666666667, 65.5833333333333],
      120: [56.0000000000001, 60, 65.9999999999999],
      121: [56.3333333333335, 60.4166666666667, 66.4999999999999],
      122: [56.6666666666668, 60.8333333333333, 66.9999999999999],
      123: [57.0000000000001, 61.25, 67.4999999999999],
      124: [57.3333333333335, 61.6666666666667, 67.9999999999999],
      125: [57.6666666666668, 62.0833333333333, 68.4999999999999],
      126: [58.0000000000002, 62.5, 68.9999999999999],
      127: [58.3333333333335, 62.9166666666667, 69.4999999999999],
      128: [58.6666666666668, 63.3333333333333, 69.9999999999999],
      129: [59.0000000000002, 63.75, 70.4999999999999],
      130: [59.3333333333335, 64.1666666666666, 70.9999999999999],
      131: [59.6666666666668, 64.5833333333333, 71.4999999999999],
      132: [60.0000000000002, 65, 71.9999999999999],
      133: [60.3333333333335, 65.3333333333333, 72.4166666666666],
      134: [60.6666666666668, 65.6666666666666, 72.8333333333333],
      135: [61.0000000000002, 66, 73.25],
      136: [61.3333333333335, 66.3333333333333, 73.6666666666666],
      137: [61.6666666666668, 66.6666666666666, 74.0833333333333],
      138: [62.0000000000002, 67, 74.5],
      139: [62.3333333333335, 67.3333333333333, 74.9166666666666],
      140: [62.6666666666669, 67.6666666666666, 75.3333333333333],
      141: [63.0000000000002, 67.9999999999999, 75.75],
      142: [63.3333333333335, 68.3333333333333, 76.1666666666667],
      143: [63.6666666666669, 68.6666666666666, 76.5833333333333],
      144: [64.0000000000002, 68.9999999999999, 77],
      145: [64.3333333333335, 69.4166666666666, 77.4166666666667],
      146: [64.6666666666669, 69.8333333333333, 77.8333333333333],
      147: [65.0000000000002, 70.2499999999999, 78.25],
      148: [65.3333333333335, 70.6666666666666, 78.6666666666667],
      149: [65.6666666666668, 71.0833333333333, 79.0833333333334],
      150: [66.0000000000002, 71.5, 79.5],
      151: [66.3333333333335, 71.9166666666666, 79.9166666666667],
      152: [66.6666666666668, 72.3333333333333, 80.3333333333334],
      153: [67.0000000000002, 72.75, 80.75],
      154: [67.3333333333335, 73.1666666666666, 81.1666666666667],
      155: [67.6666666666668, 73.5833333333333, 81.5833333333334],
      156: [68.0000000000001, 74, 82.0000000000001],
      157: [68.3333333333335, 74.3333333333333, 82.5000000000001],
      158: [68.6666666666668, 74.6666666666666, 83.0000000000001],
      159: [69.0000000000001, 75, 83.5000000000001],
      160: [69.3333333333335, 75.3333333333333, 84.0000000000001],
      161: [69.6666666666668, 75.6666666666666, 84.5000000000001],
      162: [70.0000000000001, 76, 85.0000000000001],
      163: [70.3333333333334, 76.3333333333333, 85.5000000000001],
      164: [70.6666666666668, 76.6666666666666, 86.0000000000001],
      165: [71.0000000000001, 76.9999999999999, 86.5000000000001],
      166: [71.3333333333334, 77.3333333333333, 87.0000000000001],
      167: [71.6666666666668, 77.6666666666666, 87.5000000000001],
      168: [72.0000000000001, 77.9999999999999, 88.0000000000001],
      169: [72.3333333333334, 78.4166666666666, 88.4166666666667],
      170: [72.6666666666667, 78.8333333333333, 88.8333333333334],
      171: [73.0000000000001, 79.2499999999999, 89.2500000000001],
      172: [73.3333333333334, 79.6666666666666, 89.6666666666667],
      173: [73.6666666666667, 80.0833333333333, 90.0833333333334],
      174: [74.0000000000001, 80.5, 90.5000000000001],
      175: [74.3333333333334, 80.9166666666666, 90.9166666666668],
      176: [74.6666666666667, 81.3333333333333, 91.3333333333334],
      177: [75, 81.75, 91.7500000000001],
      178: [75.3333333333334, 82.1666666666666, 92.1666666666668],
      179: [75.6666666666667, 82.5833333333333, 92.5833333333334],
      180: [76, 83, 93.0000000000001],
      181: [76.3333333333334, 83.3333333333333, 95.2500000000001],
      182: [76.6666666666667, 83.6666666666666, 97.5000000000001],
      183: [77, 84, 99.7500000000001],
      184: [77.3333333333333, 84.3333333333333, 102],
      185: [77.6666666666667, 84.6666666666666, 104.25],
      186: [78, 85, 106.5],
      187: [78.3333333333333, 85.3333333333333, 108.75],
      188: [78.6666666666667, 85.6666666666666, 111],
      189: [79, 85.9999999999999, 113.25],
      190: [79.3333333333333, 86.3333333333333, 115.5],
      191: [79.6666666666666, 86.6666666666666, 117.75],
      192: [80, 86.9999999999999, 120],
      193: [80.3333333333333, 87.3333333333333, 122.25],
      194: [80.6666666666666, 87.6666666666666, 124.5],
      195: [81, 87.9999999999999, 126.75],
      196: [81.3333333333333, 88.3333333333332, 129],
      197: [81.6666666666666, 88.6666666666666, 131.25],
      198: [81.9999999999999, 88.9999999999999, 133.5],
      199: [82.3333333333333, 89.3333333333332, 135.75],
      200: [82.6666666666666, 89.6666666666666, 138],
      201: [82.9999999999999, 89.9999999999999, 140.25],
      202: [83.3333333333333, 90.3333333333332, 142.5],
      203: [83.6666666666666, 90.6666666666665, 144.75],
      204: [83.9999999999999, 90.9999999999999, 147],
      205: [84.3333333333332, 91.3333333333332, 149.25],
      206: [84.6666666666666, 91.6666666666665, 151.5],
      207: [84.9999999999999, 91.9999999999999, 153.75],
      208: [85.3333333333332, 92.3333333333332, 156],
      209: [85.6666666666666, 92.6666666666665, 158.25],
      210: [85.9999999999999, 92.9999999999998, 160.5],
      211: [86.3333333333332, 93.3333333333332, 162.75],
      212: [86.6666666666665, 93.6666666666665, 165],
      213: [86.9999999999999, 93.9999999999998, 167.25],
      214: [87.3333333333332, 94.3333333333332, 169.5],
      215: [87.6666666666665, 94.6666666666665, 171.75],
      216: [87.9999999999999, 94.9999999999998, 174],
      217: [88.3333333333332, 95.3333333333331, 176.25],
      218: [88.6666666666665, 95.6666666666665, 178.5],
      219: [88.9999999999998, 95.9999999999998, 180.75],
      220: [89.3333333333332, 96.3333333333331, 183],
      221: [89.6666666666665, 96.6666666666665, 185.25],
      222: [89.9999999999998, 96.9999999999998, 187.5],
      223: [90.3333333333332, 97.3333333333331, 189.75],
      224: [90.6666666666665, 97.6666666666664, 192],
      225: [90.9999999999998, 97.9999999999998, 194.25],
      226: [91.3333333333331, 98.3333333333331, 196.5],
      227: [91.6666666666665, 98.6666666666664, 198.75],
      228: [91.9999999999998, 98.9999999999998, 201],
      229: [92.3333333333331, 99.3333333333331, 203.25],
      230: [92.6666666666665, 99.6666666666664, 205.5],
      231: [92.9999999999998, 99.9999999999997, 207.75],
      232: [93.3333333333331, 100.333333333333, 210],
      233: [93.6666666666664, 100.666666666666, 212.25],
      234: [93.9999999999998, 101, 214.5],
      235: [94.3333333333331, 101.333333333333, 216.75],
      236: [94.6666666666664, 101.666666666666, 219],
      237: [94.9999999999998, 102, 221.25],
      238: [95.3333333333331, 102.333333333333, 223.5],
      239: [95.6666666666664, 102.666666666666, 225.75],
      240: [95.9999999999997, 103, 228],
      241: [96.3333333333331, 103.333333333333, 230.25],
      242: [96.6666666666664, 103.666666666666, 232.5],
      243: [96.9999999999997, 104, 234.75],
      244: [97.3333333333331, 104.333333333333, 237],
      245: [97.6666666666664, 104.666666666666, 239.25],
      246: [97.9999999999997, 105, 241.5],
      247: [98.333333333333, 105.333333333333, 243.75],
      248: [98.6666666666664, 105.666666666666, 246],
      249: [98.9999999999997, 106, 248.25],
      250: [99.333333333333, 106.333333333333, 250.5],
      251: [99.6666666666664, 106.666666666666, 252.75],
      252: [99.9999999999997, 107, 255]
    }
    let sizeMultiplier;
    switch ($('#dog_age_size').val()) {
      case 'small':
        sizeMultiplier = 0;
        break;
      case 'medium':
        sizeMultiplier = 1;
        break;
      case 'large':
        sizeMultiplier = 2;
        break;
    }

    $("#age-ans").text(`${Math.round(ageData[dogAge][sizeMultiplier])} Years Old`);
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#age-ans").offset().top - 160
    }, 350);
  }
});
